<template>
    <div class="d-flex flex-row flex-wrap bd-highlight mb-3 p-3">
        <div class="text-center">
            <h3 class="font-weight-bold">{{ product.Name }}</h3>
        </div>
        <div class="flex-grow-1 text-right">
            <h3>
                <span class="font-weight-bold">Price: </span>
                {{ productPrice }}
            </h3>
        </div>
        <div class="flex-break"></div>
        <ProductInformation
            v-if="hasSpecifications"
            :specifications="specifications"
            :isDevice="true"
        />
    </div>
</template>

<script>
import ProductInformation from "../../shared/components/ProductInformation";
import { toCurrency } from "../../shared/utils/formatter";
import { getProductDisplaySpecifications } from "../../shared/services/ProductHelpers";

export default {
    name: "DeviceProductInformation",
    components: {
        ProductInformation,
    },
    props: {
        product: {
            type: Object,
            required: true,
        },
    },
    computed: {
        additionalInformation() {
            return this.product.Specifications["Additional Information"];
        },
        productPrice() {
            return toCurrency(this.product.Price);
        },
        specifications() {
            return getProductDisplaySpecifications(this.product);
        },
        hasSpecifications() {
            return (
                this.specifications &&
                Object.keys(this.specifications).length > 0
            );
        },
    },
};
</script>
